import { logWarning } from './log';

// TODO discuss what additional events we want to track,
// and what payload should we pass down
// Refs: https://github.com/tes/resources/issues/6205

const getMz = () => window._mz;

/**
 * get metadata provided by mz
 */
export const getMetadata = () => {
  const metadata = {};
  const mz = getMz();
  if (mz) {
    const { pageMetadata, userMetadata } = mz;
    metadata.mz = { pageMetadata, userMetadata };
  } else {
    logWarning('could not find mz!');
  }
  // add additional data if needed
  return metadata;
};

const trackEvent = (eventName, campaignName, props) => {
  const mz = getMz();
  if (mz) {
    mz.emit(mz.events[eventName], {
      ...props,
      type: 'marketing-banners', // FIXME previously 'nag-footer'
      name: campaignName
    });
  } else {
    logWarning(`Tried to track ${eventName}, but couldn't find mz!`);
  }
};

export const trackDisplay = trackEvent.bind(null, 'DISPLAY');
export const trackClose = trackEvent.bind(null, 'CLOSE');
export const trackAccept = trackEvent.bind(null, 'ACCEPT');
